/**
 * KV Sequence Animation - 最強重複防止版
 * SP実機での重複表示を完全に防ぐ実装
 */

(function () {
	"use strict";

	// グローバル重複防止レジストリ
	if (!window.KV_SEQUENCE_REGISTRY) {
		window.KV_SEQUENCE_REGISTRY = {
			instances: new Set(),
			scriptLoads: 0,
			initialized: false,
			initializeTime: null,
		};
	}

	const scriptId = "kv-sequence-script-" + Date.now() + "-" + Math.random().toString(36).substr(2, 9);
	const registry = window.KV_SEQUENCE_REGISTRY;

	// スクリプト読み込み回数をカウント
	registry.scriptLoads++;

	console.log("🔄 KV Sequence: 最強重複防止チェック", {
		scriptId: scriptId,
		scriptLoads: registry.scriptLoads,
		registryInstances: registry.instances.size,
		kvSequenceInitialized: window.kvSequenceInitialized,
		kvSequenceInitializing: window.kvSequenceInitializing,
		kvSequenceAttempted: window.kvSequenceAttempted,
		registryInitialized: registry.initialized,
		timestamp: new Date().toISOString(),
	});

	// 軽量な重複チェック（SP実機対応）
	const hasCanvasMarker = document.querySelector('#kv-sequence-canvas[data-initialized="true"]');
	// ScrollTrigger.getAll()はSP実機では重いため簡略化
	const hasActiveScrollTrigger = false;

	// 基本的な重複防止のみ（厳しすぎる制限を緩和）
	if (window.kvSequenceInitialized || (window.kvSequenceInitializing && hasCanvasMarker)) {
		console.log("⚠️ KV Sequence: 重複防止発動 - スキップ", {
			scriptId: scriptId,
			initialized: window.kvSequenceInitialized,
			initializing: window.kvSequenceInitializing,
			canvasInitialized: !!hasCanvasMarker,
			activeScrollTrigger: hasActiveScrollTrigger,
		});
		return;
	}

	// 全フラグと状態を即座に設定
	window.kvSequenceInitialized = false;
	window.kvSequenceInitializing = true;
	window.kvSequenceAttempted = true;
	registry.initialized = true;
	registry.initializeTime = Date.now();
	registry.instances.add("kv-sequence-main");

	// キャンバスに複数のマークを追加
	const canvas = document.querySelector("#kv-sequence-canvas");
	if (canvas) {
		canvas.setAttribute("data-initialized", "true");
		canvas.setAttribute("data-script-id", scriptId);
		canvas.setAttribute("data-init-time", Date.now().toString());
		canvas.style.setProperty("--kv-initialized", "true");
	}

	// セクションにもマークを追加
	const section = document.querySelector(".c-kv-sequence");
	if (section) {
		section.setAttribute("data-kv-initialized", "true");
		section.setAttribute("data-script-id", scriptId);
	}

	// 基本設定
	const KV_CONFIG = {
		sectionClass: ".c-kv-sequence",
		canvasId: "#kv-sequence-canvas",
		imageCount: 45,
		imageBaseUrl: "https://cdn.shopify.com/s/files/1/0684/9662/1802/files/",
		imageFormat: ".png",
	};

	// 状態管理
	const kvState = {
		images: [],
		currentFrame: 0,
		canvas: null,
		ctx: null,
		isInitialized: false,
		sequenceCompleted: false, // シーケンス完了フラグ
	};

	// 初期化（適度な重複防止機能付き）
	function initKVSequence() {
		// 基本的な初期化チェック
		if (kvState.isInitialized) {
			console.log("⚠️ KV initKVSequence: 既に初期化済み");
			return;
		}

		// 初期化開始マーク
		registry.instances.add("kv-sequence-initializing");

		const section = document.querySelector(KV_CONFIG.sectionClass);
		const canvas = document.querySelector(KV_CONFIG.canvasId);
		const canvasContainer = canvas ? canvas.closest(".c-kv-sequence__canvas-container") : null;

		if (!section || !canvas) {
			console.error("❌ KV Sequence: 必要な要素が見つかりません");
			// エラー時はフラグをクリーンアップ
			window.kvSequenceInitializing = false;
			registry.instances.delete("kv-sequence-initializing");
			return;
		}

		console.log("🚀 KV Sequence: 最強防止版初期化開始", {
			scriptId: scriptId,
			registrySize: registry.instances.size,
		});

		kvState.canvas = canvas;
		kvState.ctx = canvas.getContext("2d");
		
		// 動的CSS適用（ScrollTriggerピン留め完全対応）
		const isMobile = window.innerWidth <= 750;
		
		// セクションのスタイルを動的に設定（高さを明示的に指定）
		const viewportHeight = window.innerHeight;
		Object.assign(section.style, {
			alignItems: 'center',
			background: 'transparent',
			display: 'flex',
			flexDirection: 'column',
			height: `${viewportHeight}px`, // pxで明示的に指定
			maxHeight: `${viewportHeight}px`, // 最大高さも制限
			justifyContent: 'center',
			margin: '0',
			overflow: 'hidden',
			position: 'relative',
			width: '100%',
			// transform関連は完全にリセット
			transform: '',
			translate: '',
			rotate: '',
			scale: '',
			willChange: 'auto'
		});
		
		// キャンバスコンテナのスタイルを動的に設定
		if (canvasContainer) {
			Object.assign(canvasContainer.style, {
				alignItems: 'center',
				display: 'flex',
				height: '100%',
				justifyContent: 'center',
				position: 'relative',
				width: '100%',
				// transform関連は設定しない
				transform: 'none',
				willChange: 'auto'
			});
		}
		
		// キャンバスのスタイルを動的に設定
		Object.assign(canvas.style, {
			display: 'block',
			maxWidth: isMobile ? 'none' : '670px',
			objectFit: isMobile ? 'cover' : 'contain',
			width: '100%',
			imageRendering: 'crisp-edges'
		});
		
		// モバイル固有の設定
		if (isMobile) {
			section.style.overflowX = 'hidden';
			if (canvasContainer) {
				canvasContainer.style.overflowX = 'hidden';
			}
		}
		
		console.log("📱 動的CSS適用完了", { isMobile });

		// 画像読み込み
		loadImages()
			.then(() => {
				console.log("✅ 画像読み込み完了、キャンバスとScrollTriggerを設定中...");

				setupCanvas();
				console.log("✅ キャンバス設定完了");

				setupScrollTrigger(section);
				console.log("✅ ScrollTrigger設定完了");

				kvState.isInitialized = true;

				// 完全な初期化完了マーク
				window.kvSequenceInitialized = true;
				window.kvSequenceInitializing = false;
				registry.instances.delete("kv-sequence-initializing");
				registry.instances.add("kv-sequence-completed");

				// キャンバスに完了マークを追加
				if (canvas) {
					canvas.setAttribute("data-init-completed", "true");
					canvas.setAttribute("data-completion-time", Date.now().toString());
				}

				// 全ScrollTriggerを確認
				const allTriggers = ScrollTrigger.getAll();
				const kvTriggers = allTriggers.filter((t) => t.vars.id === "kv-sequence-trigger");

				console.log("✅ KV Sequence: 初期化完全完了", {
					scriptId: scriptId,
					kvSequenceInitialized: window.kvSequenceInitialized,
					kvSequenceInitializing: window.kvSequenceInitializing,
					totalImages: kvState.images.length,
					canvasSize: `${kvState.canvasWidth}x${kvState.canvasHeight}`,
					allTriggersCount: allTriggers.length,
					kvTriggersCount: kvTriggers.length,
					completionTime: Date.now(),
				});
			})
			.catch((error) => {
				console.error("❌ KV Sequence: 初期化エラー", error);
				// エラー時は全フラグをクリーンアップ
				window.kvSequenceInitializing = false;
				window.kvSequenceInitialized = false;
				registry.instances.delete("kv-sequence-initializing");
				if (canvas) {
					canvas.removeAttribute("data-initialized");
					canvas.removeAttribute("data-script-id");
				}
			});
	}

	// 画像読み込み
	function loadImages() {
		const promises = [];

		for (let i = 1; i <= KV_CONFIG.imageCount; i++) {
			const image = new Image();
			const imageUrl = `${KV_CONFIG.imageBaseUrl}${String(i).padStart(4, "0")}${KV_CONFIG.imageFormat}`;

			const promise = new Promise((resolve, reject) => {
				image.onload = () => {
					console.log(`✅ KV Image loaded: ${imageUrl}`);
					resolve(image);
				};
				image.onerror = (error) => {
					console.error(`❌ KV Image failed to load: ${imageUrl}`, error);
					reject(error);
				};
			});

			console.log(`🔄 KV Loading image ${i}: ${imageUrl}`);
			image.src = imageUrl;
			promises.push(promise);
		}

		return Promise.all(promises)
			.then((images) => {
				kvState.images = images;
				console.log(`✅ KV Sequence: ${images.length}枚の画像を読み込み完了`);
			})
			.catch((error) => {
				console.error("❌ KV Sequence: 画像読み込みエラー", error);
				throw error;
			});
	}

	// キャンバス設定
	function setupCanvas() {
		const canvas = kvState.canvas;
		const ctx = kvState.ctx;

		// デバイスピクセル比（DPR）を取得
		const dpr = window.devicePixelRatio || 1;

		// すべての画像の最大サイズを計算
		let maxImageWidth = 0;
		let maxImageHeight = 0;

		kvState.images.forEach((img) => {
			maxImageWidth = Math.max(maxImageWidth, img.naturalWidth);
			maxImageHeight = Math.max(maxImageHeight, img.naturalHeight);
		});

		// 最大サイズの画像のアスペクト比を使用
		const maxAspectRatio = maxImageWidth / maxImageHeight;

		// PCでの画質改善：元画像サイズを優先したキャンバスサイズ設定
		let maxWidth, height;

		if (window.innerWidth > 750) {
			// PCの場合：元画像サイズを活かしつつ、適切なサイズに調整
			const maxDisplayWidth = 670; // 表示幅の上限
			const maxDisplayHeight = 600; // 表示高さの上限

			// 元画像サイズと表示上限の両方を考慮
			if (maxImageWidth <= maxDisplayWidth && maxImageHeight <= maxDisplayHeight) {
				// 元画像が表示上限内の場合：元画像サイズをそのまま使用
				maxWidth = maxImageWidth;
				height = maxImageHeight;
			} else {
				// 元画像が表示上限を超える場合：アスペクト比を保ちながら縮小
				const scaleX = maxDisplayWidth / maxImageWidth;
				const scaleY = maxDisplayHeight / maxImageHeight;
				const scale = Math.min(scaleX, scaleY, 1); // 拡大はしない

				maxWidth = maxImageWidth * scale;
				height = maxImageHeight * scale;
			}
		} else {
			// モバイルの場合：従来通りの処理
			maxWidth = window.innerWidth * 1.3;
			height = maxWidth / maxAspectRatio;
		}

		// 高解像度ディスプレイ対応：キャンバスの実際のサイズをDPR倍に設定
		canvas.width = maxWidth * dpr;
		canvas.height = height * dpr;

		// 表示サイズは現状のまま維持
		canvas.style.width = maxWidth + "px";
		canvas.style.height = height + "px";
		canvas.style.maxWidth = window.innerWidth > 750 ? "100%" : "none"; // モバイルでは幅制限なし
		canvas.style.maxHeight = height + "px";

		// コンテキストのスケールをDPR倍に設定
		ctx.scale(dpr, dpr);

		// 画像描画品質を向上
		ctx.imageSmoothingEnabled = true;
		ctx.imageSmoothingQuality = "high";

		// グローバル変数に保存
		kvState.canvasWidth = maxWidth;
		kvState.canvasHeight = height;
		kvState.dpr = dpr;

		console.log("キャンバスサイズ設定:", {
			maxImageWidth: maxImageWidth,
			maxImageHeight: maxImageHeight,
			maxAspectRatio: maxAspectRatio,
			canvasWidth: maxWidth,
			canvasHeight: height,
			dpr: dpr,
			actualCanvasWidth: canvas.width,
			actualCanvasHeight: canvas.height,
			deviceType: window.innerWidth > 750 ? "PC" : "Mobile",
		});

		// 最初のフレームを表示
		if (kvState.images[0]) {
			drawFrame(0);
		}
	}

	// パフォーマンス計測用変数
	let lastFrameTime = performance.now();
	let longTaskCount = 0;
	let frameTimeStats = [];

	// フレーム描画（パフォーマンス計測版）
	function drawFrame(frameIndex) {
		const frameStart = performance.now();
		
		// drawFrame呼び出しログ（重要なフレームのみ）
		if (frameIndex % 5 === 0 || frameIndex === kvState.images.length - 1) {
			console.log(`🎨 drawFrame called with frameIndex: ${frameIndex}`);
		}

		if (!kvState.ctx || !kvState.images[frameIndex]) {
			console.error("❌ KV drawFrame: Invalid state or frame:", {
				frameIndex,
				hasCtx: !!kvState.ctx,
				hasImage: !!kvState.images[frameIndex],
				totalImages: kvState.images.length,
				canvasSize: kvState.canvas ? `${kvState.canvas.width}x${kvState.canvas.height}` : "none",
				canvasExists: !!kvState.canvas,
				kvStateInitialized: kvState.isInitialized,
			});
			return;
		}

		// SP実機での描画前の安全チェック
		if (!kvState.canvas.offsetWidth || !kvState.canvas.offsetHeight) {
			console.warn("⚠️ SP実機: キャンバスサイズが0のため描画スキップ");
			return;
		}

		// フレーム描画ログ（重要なフレームのみ）
		if (frameIndex % 5 === 0 || frameIndex === kvState.images.length - 1) {
			console.log(`🎨 KV Drawing frame ${frameIndex}/${kvState.images.length - 1}`, {
				imageNaturalSize: `${kvState.images[frameIndex].naturalWidth}x${kvState.images[frameIndex].naturalHeight}`,
				canvasSize: `${kvState.canvasWidth}x${kvState.canvasHeight}`,
			});
		}

		const ctx = kvState.ctx;
		const canvas = kvState.canvas;
		const image = kvState.images[frameIndex];
		const isMobile = window.innerWidth <= 750;

		// キャンバスをクリア
		ctx.clearRect(0, 0, kvState.canvasWidth, kvState.canvasHeight);

		// SP実機では描画品質を調整
		if (isMobile) {
			ctx.imageSmoothingEnabled = false; // SP実機では高速化優先
		} else {
			ctx.imageSmoothingEnabled = true;
			ctx.imageSmoothingQuality = "high";
		}

		// PCでの画質改善：元画像サイズを活かした描画処理
		if (window.innerWidth > 750) {
			// PCの場合：元画像サイズをそのまま使用（縮小・拡大なし）
			if (kvState.canvasWidth === image.naturalWidth && kvState.canvasHeight === image.naturalHeight) {
				// キャンバスサイズと元画像サイズが一致する場合：直接描画
				ctx.drawImage(image, 0, 0);
			} else {
				// サイズが異なる場合：アスペクト比を保ちながら中央配置
				const imageAspectRatio = image.naturalWidth / image.naturalHeight;
				const canvasAspectRatio = kvState.canvasWidth / kvState.canvasHeight;

				let drawWidth, drawHeight, offsetX, offsetY;

				if (imageAspectRatio > canvasAspectRatio) {
					// 画像が横長の場合：幅に合わせて高さを調整
					drawWidth = kvState.canvasWidth;
					drawHeight = kvState.canvasWidth / imageAspectRatio;
					offsetX = 0;
					offsetY = (kvState.canvasHeight - drawHeight) / 2;
				} else {
					// 画像が縦長の場合：高さに合わせて幅を調整
					drawHeight = kvState.canvasHeight;
					drawWidth = kvState.canvasHeight * imageAspectRatio;
					offsetX = (kvState.canvasWidth - drawWidth) / 2;
					offsetY = 0;
				}

				// 画像描画時の品質向上のため、整数座標に調整
				offsetX = Math.round(offsetX);
				offsetY = Math.round(offsetY);
				drawWidth = Math.round(drawWidth);
				drawHeight = Math.round(drawHeight);

				ctx.drawImage(image, offsetX, offsetY, drawWidth, drawHeight);
			}
		} else {
			// モバイルの場合：従来通りの処理
			const imageAspectRatio = image.naturalWidth / image.naturalHeight;
			const canvasAspectRatio = kvState.canvasWidth / kvState.canvasHeight;

			let drawWidth, drawHeight, offsetX, offsetY;

			if (imageAspectRatio > canvasAspectRatio) {
				// 画像が横長の場合：幅に合わせて高さを調整
				drawWidth = kvState.canvasWidth;
				drawHeight = kvState.canvasWidth / imageAspectRatio;
				offsetX = 0;
				offsetY = (kvState.canvasHeight - drawHeight) / 2;
			} else {
				// 画像が縦長の場合：高さに合わせて幅を調整
				drawHeight = kvState.canvasHeight;
				drawWidth = kvState.canvasHeight * imageAspectRatio;
				offsetX = (kvState.canvasWidth - drawWidth) / 2;
				offsetY = 0;
			}

			// 画像描画時の品質向上のため、整数座標に調整
			offsetX = Math.round(offsetX);
			offsetY = Math.round(offsetY);
			drawWidth = Math.round(drawWidth);
			drawHeight = Math.round(drawHeight);

			ctx.drawImage(image, offsetX, offsetY, drawWidth, drawHeight);
		}

		kvState.currentFrame = frameIndex;

		// パフォーマンス計測（frameEnd）
		const frameEnd = performance.now();
		const frameTime = frameEnd - frameStart;
		const rAFTime = frameEnd - lastFrameTime;
		lastFrameTime = frameEnd;

		// Long Task検出（50ms超過）
		if (frameTime > 50) {
			longTaskCount++;
			console.warn("🐌 Long Task detected:", {
				frameIndex: frameIndex,
				frameTime: `${frameTime.toFixed(2)}ms`,
				rAFTime: `${rAFTime.toFixed(2)}ms`,
				longTaskCount: longTaskCount
			});
		}

		// フレーム統計を記録（直近20フレーム）
		frameTimeStats.push({ frameTime, rAFTime, frameIndex });
		if (frameTimeStats.length > 20) {
			frameTimeStats.shift();
		}

		// 5フレームごとにパフォーマンス統計を出力
		if (frameIndex % 5 === 0) {
			const avgFrameTime = frameTimeStats.reduce((sum, stat) => sum + stat.frameTime, 0) / frameTimeStats.length;
			const avgRAFTime = frameTimeStats.reduce((sum, stat) => sum + stat.rAFTime, 0) / frameTimeStats.length;
			
			// メモリ使用量監視（Safari RAM圧迫対策）
			let memoryInfo = { memoryUsage: 'unknown' };
			if (performance.memory) {
				memoryInfo = {
					usedJSHeapSize: `${(performance.memory.usedJSHeapSize / 1048576).toFixed(1)}MB`,
					totalJSHeapSize: `${(performance.memory.totalJSHeapSize / 1048576).toFixed(1)}MB`,
					jsHeapSizeLimit: `${(performance.memory.jsHeapSizeLimit / 1048576).toFixed(1)}MB`,
					memoryPressure: (performance.memory.usedJSHeapSize / performance.memory.jsHeapSizeLimit) > 0.8 ? '⚠️HIGH' : '✅OK'
				};
			} else if (navigator.deviceMemory) {
				memoryInfo = { deviceMemory: `${navigator.deviceMemory}GB` };
			}
			
			console.log("📊 Performance Stats:", {
				frameIndex: frameIndex,
				avgFrameTime: `${avgFrameTime.toFixed(2)}ms`,
				avgRAFTime: `${avgRAFTime.toFixed(2)}ms`,
				longTasks: longTaskCount,
				fps: Math.round(1000 / avgRAFTime),
				...memoryInfo,
				canvasSize: `${kvState.canvasWidth}x${kvState.canvasHeight}`,
				imageCount: kvState.images.length
			});
			
			// メモリ圧迫警告
			if (performance.memory && (performance.memory.usedJSHeapSize / performance.memory.jsHeapSizeLimit) > 0.9) {
				console.warn("🚨 Memory Pressure: RAM圧迫でSafariタブ再ロードの可能性");
			}
		}
	}

	// ScrollTrigger設定（適度な重複防止機能付き）
	function setupScrollTrigger(section) {
		const isMobile = window.innerWidth <= 750;

		// ScrollTrigger重複防止強化
		const existingTriggers = ScrollTrigger.getAll().filter((trigger) => trigger.vars.id === "kv-sequence-trigger");
		const sectionHasTrigger = section.hasAttribute("data-scrolltrigger-active");

		// 重複チェック
		if (existingTriggers.length > 0 || sectionHasTrigger) {
			console.log("⚠️ ScrollTrigger 重複防止発動", {
				existingTriggers: existingTriggers.length,
				sectionHasTrigger: sectionHasTrigger,
				scriptId: scriptId,
			});
			return;
		}

		// 既存のトリガーを完全にクリーンアップ
		if (existingTriggers.length > 0) {
			console.log("🧹 Cleaning up existing KV ScrollTriggers:", existingTriggers.length);
			existingTriggers.forEach((trigger) => trigger.kill());
		}

		// ScrollTrigger設定マーク
		section.setAttribute("data-scrolltrigger-setup", "true");
		section.setAttribute("data-scrolltrigger-active", "true");

		console.log("🎬 ScrollTrigger 設定開始", {
			deviceType: isMobile ? "Mobile" : "Desktop",
			scriptId: scriptId,
		});

		// SP実機用の安定設定（固定高さ）
		const viewportHeight = window.innerHeight;
		const scrollDistance = viewportHeight * 1.5; // 1.5画面分のスクロール
		
		const mobileConfig = {
			trigger: section,
			start: "top top",
			end: () => `+=${scrollDistance}`,
			pin: true,
			pinSpacing: true,
			scrub: 1,
			id: "kv-sequence-trigger-mobile",
			markers: false,
			pinSpacer: {
				// pin-spacerの初期設定
				start: () => {
					// pin-spacerが生成されたら即座に修正
					requestAnimationFrame(() => {
						const ps = document.querySelector('.pin-spacer-kv-sequence-trigger-mobile');
						if (ps) {
							ps.style.height = `${scrollDistance}px`;
							ps.style.padding = '0';
							console.log("📱 pin-spacer初期設定:", scrollDistance);
						}
					});
				}
			},
			onUpdate: function (self) {
				handleMobileFrameUpdate(self);
			},
			onEnter: function(self) {
				console.log("📱 SP: アニメーション開始");
				kvState.sequenceCompleted = false;
			},
			onLeave: function (self) {
				console.log("📱 SP: アニメーション終了");
				kvState.sequenceCompleted = true;
			},
			onEnterBack: function(self) {
				console.log("📱 SP: アニメーション再開（逆方向）");
				kvState.sequenceCompleted = false;
			},
			onLeaveBack: function (self) {
				console.log("📱 SP: アニメーション開始前に戻る");
				kvState.sequenceCompleted = false;
				if (kvState.images[0]) {
					drawFrame(0);
				}
			}
		};

		// PC用の設定
		const desktopConfig = {
			trigger: section,
			start: "top top",
			end: "+=300%",
			pin: true,
			pinSpacing: true,
			scrub: true,
			invalidateOnRefresh: true, // リサイズ時の再計算を有効化
			priority: 1,
			preventOverlaps: true,
			id: "kv-sequence-trigger",
			onUpdate: function (self) {
				// シーケンス完了後は前進のみ停止（逆再生は許可）
				const isReverseDirection = self.direction === -1;
				if (kvState.sequenceCompleted && !isReverseDirection) {
					console.log("🚫 PC: シーケンス完了済み - 前進フレーム描画をスキップ");
					return;
				}
				
				// 逆再生の場合は完了フラグをリセット
				if (isReverseDirection && kvState.sequenceCompleted) {
					kvState.sequenceCompleted = false;
					console.log("🔄 PC: 逆再生検知 - シーケンス完了フラグをリセット");
				}

				const progress = self.progress;
				const totalFrames = kvState.images.length - 1;
				const targetFrame = Math.round(progress * totalFrames);

				// 逆再生デバッグ情報
				if (isReverseDirection) {
					console.log("🔄 PC: 逆再生中", {
						direction: self.direction,
						progress: progress.toFixed(3),
						targetFrame: targetFrame,
						currentFrame: kvState.currentFrame,
						sequenceCompleted: kvState.sequenceCompleted
					});
				}

				// KVフレーム更新ログ（間引き表示）
				if (Math.round(progress * 50) % 3 === 0) {
					// 6%ごとに表示
					console.log("🖥️ Desktop KV frame update:", {
						progress: progress.toFixed(3),
						targetFrame: targetFrame,
						currentFrame: kvState.currentFrame,
						totalFrames: totalFrames,
						hasImages: kvState.images.length > 0,
						hasTargetImage: !!kvState.images[targetFrame],
						direction: self.direction === 1 ? "↓" : "↑",
					});
				}

				if (targetFrame !== kvState.currentFrame && kvState.images[targetFrame]) {
					// 短時間での重複描画を防止（PC版）
					const now = Date.now();
					const timeSinceLastDraw = window.lastKVDrawTime ? now - window.lastKVDrawTime : Infinity;

					if (timeSinceLastDraw < 16) {
						// 60fps制限（16ms）
						return;
					}

					window.lastKVDrawTime = now;

					// フレーム描画ログ（重要なフレームのみ）
					if (targetFrame % 5 === 0 || targetFrame === totalFrames) {
						console.log(`🎨 Desktop drawing frame ${targetFrame}`);
					}
					drawFrame(targetFrame);
				}
			},
			onLeaveBack: function (self) {
				console.log("🖥️ KV Desktop onLeaveBack: シーケンス復帰");
				// シーケンス復帰時は完了フラグをリセット
				kvState.sequenceCompleted = false;
				console.log("🔄 Desktop: onLeaveBack - シーケンス完了フラグをリセット");
			},
		};

		console.log("🔧 ScrollTrigger設定:", isMobile ? mobileConfig : desktopConfig);

		const createdTrigger = ScrollTrigger.create(isMobile ? mobileConfig : desktopConfig);

		// ScrollTrigger作成完了確認
		if (createdTrigger) {
			console.log("✅ ScrollTrigger 作成完了", {
				triggerId: createdTrigger.id,
				deviceType: isMobile ? "Mobile" : "Desktop",
				// SP実機ピンドメ初期状態調査
				initialTriggerRect: section.getBoundingClientRect(),
				initialSectionHeight: section.offsetHeight,
				initialViewportHeight: window.innerHeight,
				initialVisualViewportHeight: window.visualViewport?.height || 'N/A',
				initialScrollY: window.pageYOffset,
				calculatedStart: createdTrigger.start,
				calculatedEnd: createdTrigger.end,
				trigger: createdTrigger.trigger,
				start: createdTrigger.start,
				end: createdTrigger.end,
				scriptId: scriptId,
			});
			
			// pin-spacer要素の強制修正
			if (isMobile) {
				const viewportHeight = window.innerHeight;
				const targetHeight = viewportHeight * 1.5; // 1.5画面分
				
				// 積極的な修正関数
				const forcePinSpacerFix = () => {
					const pinSpacer = document.querySelector('.pin-spacer-kv-sequence-trigger-mobile');
					if (pinSpacer) {
						// 現在の値を取得
						const currentHeight = parseInt(pinSpacer.style.height) || 0;
						const currentPadding = parseInt(pinSpacer.style.paddingBottom) || 0;
						
						// 異常な値の場合は強制修正
						if (currentHeight > targetHeight * 1.5 || currentPadding > 0) {
							pinSpacer.style.cssText += `
								height: ${targetHeight}px !important;
								padding: 0 !important;
								padding-bottom: 0 !important;
								max-height: ${targetHeight}px !important;
							`;
							
							console.log("📱 pin-spacer強制修正実行", {
								before: { height: currentHeight, padding: currentPadding },
								after: { height: targetHeight, padding: 0 }
							});
							
							// セクション内のtransformもリセット
							const sectionInside = pinSpacer.querySelector('.c-kv-sequence');
							if (sectionInside) {
								const transform = sectionInside.style.transform;
								if (transform && transform !== 'translate(0px, 0px)') {
									sectionInside.style.transform = 'translate(0px, 0px)';
									console.log("📱 transform修正:", transform, "→ translate(0px, 0px)");
								}
							}
						}
					}
				};
				
				// 複数のタイミングで修正を実行
				setTimeout(forcePinSpacerFix, 100);
				setTimeout(forcePinSpacerFix, 300);
				setTimeout(forcePinSpacerFix, 500);
				setTimeout(forcePinSpacerFix, 1000);
				
				// スクロールイベントでも修正
				let scrollCount = 0;
				const scrollFix = () => {
					if (scrollCount < 10) { // 最初の10回のスクロールで修正
						forcePinSpacerFix();
						scrollCount++;
					}
				};
				window.addEventListener('scroll', scrollFix, { passive: true, once: false });
				
				// MutationObserverでも監視
				const observer = new MutationObserver(() => {
					forcePinSpacerFix();
				});
				
				setTimeout(() => {
					const pinSpacer = document.querySelector('.pin-spacer-kv-sequence-trigger-mobile');
					if (pinSpacer) {
						observer.observe(pinSpacer, {
							attributes: true,
							attributeFilter: ['style'],
							subtree: true
						});
						console.log("📱 pin-spacer監視開始（強制修正モード）");
					}
				}, 200);
			}

			// SP実機専用：ScrollTrigger.refresh制限（start位置保護）
			if (isMobile) {
				let refreshCount = 0;
				const maxRefreshes = 3; // 最大リフレッシュ回数制限
				
				const originalRefresh = ScrollTrigger.refresh;
				
				ScrollTrigger.refresh = function(...args) {
					refreshCount++;
					
					if (refreshCount > maxRefreshes) {
						console.log("🚫 SP実機: ScrollTrigger.refresh制限発動 - start位置保護", {
							refreshCount: refreshCount,
							maxRefreshes: maxRefreshes
						});
						return; // refresh実行を阻止
					}
					
					console.log("🔄 SP実機: ScrollTrigger.refresh実行", {
						refreshCount: refreshCount,
						scrollY: window.pageYOffset,
						triggerStart: createdTrigger.start
					});
					
					const result = originalRefresh.apply(this, args);
					
					// start位置のマイナス値を強制修正
					if (createdTrigger.start < 0) {
						console.log("🔧 SP実機: start位置マイナス値を強制修正", {
							before: createdTrigger.start,
							after: 105
						});
						// 内部的にstart値を修正（可能であれば）
						try {
							createdTrigger.start = 105;
						} catch (e) {
							console.warn("⚠️ start位置修正に失敗:", e.message);
						}
					}
					
					return result;
				};
			}
		} else {
			console.error("❌ ScrollTrigger 作成失敗");
		}
	}

	// SP実機用の安定したフレーム更新処理（ScrollTrigger direction利用版）
	function handleMobileFrameUpdate(self) {
		const progress = self.progress;
		const direction = self.direction; // ScrollTriggerのdirectionを使用
		const totalFrames = kvState.images.length - 1;
		const targetFrame = Math.round(progress * totalFrames);
		
		// フレーム計算（確実にクランプ）
		const clampedFrame = Math.max(0, Math.min(totalFrames, targetFrame));
		
		// デバッグログ
		if (targetFrame !== kvState.lastLoggedFrame) {
			console.log(`📱 SP: ${direction === -1 ? '↑逆再生' : '↓前進'} | progress: ${progress.toFixed(3)} | frame: ${clampedFrame}/${totalFrames} | dir: ${direction}`);
			kvState.lastLoggedFrame = targetFrame;
		}
		
		// フレーム描画判定（シンプルに）
		if (clampedFrame !== kvState.currentFrame && kvState.images[clampedFrame]) {
			// 逆再生時はFPS制限なし、前進時のみ制限
			if (direction === 1) { // 前進時
				const now = Date.now();
				const timeSinceLastDraw = kvState.lastDrawTime || 0;
				
				if (now - timeSinceLastDraw < 33) { // 30fps制限
					return;
				}
				kvState.lastDrawTime = now;
			}
			
			// フレーム描画実行
			console.log(`🎨 SP描画: frame ${clampedFrame} (${direction === -1 ? '逆再生' : '前進'})`);
			drawFrame(clampedFrame);
		}
	}

	// リサイズ対応（最強重複防止機能付き）
	function handleResize() {
		// 重複リサイズ処理を防止
		const currentTime = Date.now();
		const timeSinceLastResize = window.lastKVResizeTime ? currentTime - window.lastKVResizeTime : Infinity;

		if (timeSinceLastResize < 100) {
			// 100ms以内の重複リサイズを防止
			console.log("🚨 KV Resize: 重複防止スキップ", { timeSinceLastResize });
			return;
		}

		window.lastKVResizeTime = currentTime;

		if (kvState.isInitialized && registry.instances.has("kv-sequence-completed")) {
			const isMobile = window.innerWidth <= 750;

			console.log("🔄 KV 最強防止版 Resize handling", {
				deviceType: isMobile ? "Mobile" : "Desktop",
				scriptId: scriptId,
				resizeTime: currentTime,
			});

			// SP実機では頻繁なリサイズを制限
			if (isMobile) {
				// ScrollTriggerのリフレッシュのみ（kill/recreateは避ける）
				const trigger = ScrollTrigger.getById("kv-sequence-trigger");
				if (trigger && !registry.instances.has("kv-resize-processing")) {
					registry.instances.add("kv-resize-processing");
					trigger.refresh();
					ScrollTrigger.refresh(); // 全体の再計算も実行
					console.log("📱 KV Mobile: ScrollTrigger refreshed only");
					setTimeout(() => {
						registry.instances.delete("kv-resize-processing");
					}, 500);
				}
				return;
			}

			// PC用リサイズ処理の重複防止
			if (registry.instances.has("kv-pc-resize-processing")) {
				console.log("🚨 PC Resize: 処理中のためスキップ");
				return;
			}

			registry.instances.add("kv-pc-resize-processing");

			// PCのみフル再初期化
			ScrollTrigger.getAll().forEach((trigger) => {
				if (trigger.trigger === document.querySelector(KV_CONFIG.sectionClass)) {
					trigger.kill();
				}
			});

			setupCanvas();

			// SP実機では安全な設定のみ
			const canvas = document.querySelector(KV_CONFIG.canvasId);
			const canvasContainer = canvas ? canvas.closest(".c-kv-sequence__canvas-container") : null;
			if (window.innerWidth <= 750 && canvasContainer) {
				canvasContainer.style.width = "100%";
				canvasContainer.style.overflowX = "hidden";
			}

			// ScrollTriggerを再設定
			const section = document.querySelector(KV_CONFIG.sectionClass);
			if (section) {
				// 再設定前にフラグをリセット
				section.removeAttribute("data-scrolltrigger-setup");
				section.removeAttribute("data-scrolltrigger-completed");
				registry.instances.delete("kv-scrolltrigger-active");
				registry.instances.delete("kv-scrolltrigger-completed");

				setupScrollTrigger(section);
			}

			// PC処理完了マーク
			setTimeout(() => {
				registry.instances.delete("kv-pc-resize-processing");
			}, 1000);
		}
	}

	// イベントリスナー
	window.addEventListener("resize", handleResize);

	// DOM読み込み完了後に初期化（適度な重複防止機能付き）
	function safeInitKVSequence() {
		// 基本的な重複チェック
		if (window.kvSequenceInitialized) {
			console.log("⚠️ safeInitKVSequence: 既に初期化済み");
			return;
		}

		console.log("🔍 safeInitKVSequence: 実行", {
			readyState: document.readyState,
			scriptId: scriptId,
		});

		// 要素存在チェック
		const section = document.querySelector(".c-kv-sequence");
		const canvas = document.querySelector("#kv-sequence-canvas");

		if (!section || !canvas) {
			console.log("⚠️ KV Sequence: 必要な要素が見つからないため初期化をスキップ");
			return;
		}

		initKVSequence();
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", safeInitKVSequence);
	} else {
		// DOMが既に読み込み完了している場合は即座に実行
		safeInitKVSequence();
	}

	// グローバルに実行状態を記録
	window.KV_SEQUENCE_SCRIPT_LOADED = true;
	window.KV_SEQUENCE_SCRIPT_ID = scriptId;

	console.log("🏁 KV Sequence 重複防止版スクリプト読み込み完了", {
		scriptId: scriptId,
		timestamp: new Date().toISOString(),
	});
})();
